import { Link } from 'react-router-dom';
const TechnologySection = () => {
  return (
    <section className="about about--style1 bg-color xts-section">
      <div className="container">
        <div className="about__wrapper">
          <div className="row align-items-center">
            <div className="col-lg-12">
              <div className="about__content" data-aos="fade-left" data-aos-duration="800">
                <div className="about__content-inner">
                  <h2 className="meet-oppurtanity"> Trading <span>Platform</span></h2>
                  <div className="row justify-content-center trad-platform">
                    <div className="col-md-4">
                      <div className="mt-2">
                        <div className="bg-gradients">
                          <a target="_blank" href="https://trading.asiaticstock.in/#!/app">
                            <h3>Online Trading</h3>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="mt-2">
                        <div className="bg-gradients">
                          <a target="_blank" href="https://play.google.com/store/apps/details?id=com.asiaticstock.xts&pli=1">
                            <h3>Mobile Trading</h3>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="mt-2">
                        <div className="bg-gradients">
                          <Link to="/greeks">
                            <h3>Greeks</h3>
                          </Link>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="mt-2">
                        <div className="bg-gradients">
                          <Link to="/symphony-XTS">
                            <h3>Symphony XTS</h3>
                          </Link>
                        </div>
                      </div>
                    </div>
                    {/* <div className="col-md-4">
                      <div className="mt-2">
                        <div className="bg-gradients">
                          <Link to="/ami-brokers">
                            <h3>Ami-broker</h3>
                          </Link>
                        </div>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TechnologySection;